<script lang="ts">
  import { cancelUpload, uploads } from "state/upload";
  import {
    onlineState,
    returnToDetails as onEditCancel,
    returnToSearchPage,
    pageState,
  } from "state/page";
  import { getEditOnlyMode } from "services/plugin-customization";
  import { closePluginCallback } from "services/pluginMessages";
  import { editActor, editState, selectImageOnSave } from "components/Editor/editSession";
  import { requiredFieldsMissing, validDate } from "components/Editor/editImageMachine";
  import BottomActionBar from "./BottomActionBar.svelte";

  const editOnlyMode = getEditOnlyMode();

  $: isSaving = $editState?.matches("Saving") ?? false;
  $: missingFields = $editState ? requiredFieldsMissing($editState) : true;
  $: invalidDate = $editState ? !validDate($editState) : true;
  $: tiffImage =
    !!$editState?.context.images[0] && $editState.context.images[0].mediaType === "image/tiff";
  $: uploadsInProgress = $uploads.state === "IN_PROGRESS";
  $: disabled =
    isSaving ||
    uploadsInProgress ||
    $onlineState === "OFFLINE" ||
    missingFields ||
    !!$editState?.matches("Error") ||
    invalidDate ||
    tiffImage;
  $: label = $selectImageOnSave && !editOnlyMode ? "Bruk bilde" : "Lagre";

  $: offlineError =
    $onlineState === "OFFLINE" ? "Du må koble til Internett for å kunne lagre" : undefined;

  // Edit.svelte renders its own error page when in "Error" state,
  // so only surface the error message here for non-terminal errors (e.g. save failures).
  $: stateMachineError = $editState?.matches("Error")
    ? undefined
    : $editState?.context.error?.message;

  $: tiffFormatError = tiffImage
    ? "TIFF-filer (.tiff) kan ikke publiseres eller brukes"
    : undefined;

  $: missingFieldsError = missingFields ? "Obligatoriske felter må fylles ut" : undefined;

  $: statusMessages = [offlineError, stateMachineError, tiffFormatError, missingFieldsError].filter(
    (msg): msg is string => !!msg,
  );

  $: onCancel = editOnlyMode
    ? closePluginCallback
    : $pageState.type === "UPLOAD"
      ? onUploadCancel
      : $pageState.type === "EDIT"
        ? onEditCancel($pageState.itemIds)
        : undefined;

  async function onUploadCancel() {
    if (confirm("Hvis du avbryter vil opplastingene slettes")) {
      await cancelUpload();
      returnToSearchPage();
    }
  }
</script>

<BottomActionBar
  {label}
  onAction={() => $editActor?.send({ type: "SUBMIT" })}
  busy={isSaving}
  {disabled}
  secondaryLabel="Avbryt"
  secondaryOnAction={onCancel}
  {statusMessages}
/>
